import { useState, useEffect } from 'react';
import { fetchWithAuth } from '../../utils/api';
import logger from '../../utils/logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useInvestmentFormConfig(isOpen) {
  const [config, setConfig] = useState(null);
  const [entities, setEntities] = useState([]);
  const [relatedAssets, setRelatedAssets] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    const loadConfig = async () => {
      try {
        // Use the authenticated wrapper so the bearer token is attached.
        // The endpoint requires auth — calling it anonymously produces a
        // spurious 401 in the console for every modal open.
        const res = await fetchWithAuth(`${BACKEND_URL}/api/investments/config`);
        if (res.ok) setConfig(await res.json());
        else logger.error('Config load failed:', res.status);
      } catch (err) { logger.error('Config load error:', err); }
    };
    const loadEntities = async () => {
      try {
        const [eRes, aRes] = await Promise.all([fetchWithAuth(`${BACKEND_URL}/api/entities`), fetchWithAuth(`${BACKEND_URL}/api/related-assets`)]);
        if (eRes.ok) setEntities(await eRes.json());
        if (aRes.ok) setRelatedAssets(await aRes.json());
      } catch (err) { logger.error('Entities load error:', err); }
    };
    loadConfig();
    loadEntities();
  }, [isOpen]);

  return { config, setConfig, entities, relatedAssets };
}
